import React from 'react';
import { styled } from '@mui/material';

import { Box, Container, Tabs } from 'shell/components';

const Mobile = ({ options, tab, setTab }) => {
    return (
        <Container device={'mobile'}>
            <RootBox>
                <Tabs aria-label={'select members or teams'} options={options} selected={tab} onChange={setTab} />
            </RootBox>
        </Container>
    );
};

const RootBox = styled(Box)(() => {
    return {
        width: '100%',
    };
});

export default Mobile;
